import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "This block for memo bc component has buttonType props (look into spinnerClasses", -1)

import { ClassesProp } from '@/types/app'
import { computed } from 'vue'
import AppIcon from "@/components/app/AppIcon.vue";

interface Props {
  icon: string | string[],
  buttonType?: string,
  buttonSmall?: boolean,
  spinnerType?: string,
  loading: boolean,
  disabled?: boolean,
  disableOnLoading?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppIconLoadingButton',
  props: {
    icon: null,
    buttonType: { default: 'primary' },
    buttonSmall: { type: Boolean, default: true },
    spinnerType: { default: 'light' },
    loading: { type: Boolean },
    disabled: { type: Boolean, default: false },
    disableOnLoading: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { icon: string | string[], buttonType: string, buttonSmall: boolean, spinnerType: string, loading: boolean, disabled: boolean, disableOnLoading: boolean };



const buttonClasses = computed(() => {
  const classes: ClassesProp = {}

  classes[`btn-${props.buttonType}`] = true
  classes['btn-sm'] = props.buttonSmall

  return classes
})

const spinnerClasses = computed(() => {
  const classes: ClassesProp = {}

  classes[`text-${props.spinnerType}`] = true

  if (props.buttonType === 'light') {
    classes['text-body'] = true
  }

  return classes
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["btn", _unref(buttonClasses)]),
    disabled: props.disabled || props.loading
  }, [
    (props.loading)
      ? (_openBlock(), _createBlock(AppIcon, {
          key: 0,
          icon: "spinner",
          spin: ""
        }))
      : (_openBlock(), _createBlock(AppIcon, {
          key: 1,
          icon: props.icon
        }, null, 8, ["icon"])),
    false
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_2,
          false
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["spinner-border spinner-border-sm", _unref(spinnerClasses)]),
                role: "status"
              }, null, 2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})